// extracted by mini-css-extract-plugin
module.exports = {"flex":"Author_flex__2n7uq","flexItem":"Author_flexItem__2MM9r"};